import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class TranslateLanguageService {
    translateLanguage;
    public values: BehaviorSubject<any> = new BehaviorSubject<any>({});

    constructor(private _translate: TranslateService) {
    }

    getLanguage(language) {
        this.setLanguage();
        return language;
    }

    setLanguage() {
        this.translateLanguage = localStorage.getItem('language');
        this.translateLanguage ? this._translate.use(this.translateLanguage) : this._translate.use('en');
        return this.translateLanguage;
    }

    getTranslation(term: string) {
        return this._translate.get(term);
    }

    getTranslatedStringInstant(string) {
        return this._translate.instant(string);
    }

}




// WEBPACK FOOTER //
// /var/www/delios/delios-live/app/src/app/services/translate_language.service.ts